/**
 * Cerberus useAuth — exposes authentication state to React.
 *
 * Responsibilities:
 *   - On mount: consume `#access_token=...` redirect fragment (if any), then
 *     validate the stored access token against the JWKS.
 *   - Schedule silent refresh before exp.
 *   - Listen to `storage` events for cross-tab sync.
 *   - Surface `{user, claims, memberships, grants, activeOrgId, ...}`.
 */
import { useContext } from 'react'
import { AuthContext, type AuthContextValue } from './AuthContext'

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuth must be used inside <AuthProvider> (cerberus)')
  }
  return ctx
}
